// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__JyXuQ","right":"MainHeader_right__LuGDo","left":"MainHeader_left__A0ySn"};